/* hoemia : offres groupées (une ligne par paire), livraison estimée, avis, gravure */
(function(){
  /* ---------- Offres ---------- */
  document.querySelectorAll('[data-ho-offers]').forEach(function(fs){
    var qty=fs.querySelector('[data-ho-qty]');
    var variants=[];try{variants=JSON.parse(fs.querySelector('[data-ho-variants]').textContent)}catch(e){}
    var picker=fs.closest('form,.product__info-container,section')&&document.querySelector('variant-selects,variant-radios');
    function current(){return [].slice.call(fs.querySelectorAll('.ho-offer')).filter(function(o){return o.querySelector('input[type=radio]').checked})[0]}
    function sync(){
      fs.querySelectorAll('.ho-offer').forEach(function(o){var on=o.querySelector('input[type=radio]').checked;o.classList.toggle('is-on',on);var r=o.querySelector('.ho-offer__rows');if(r)r.hidden=!on;});
      var c=current();qty.value=c?c.getAttribute('data-qty'):1;
      var multi=c&&+c.getAttribute('data-qty')>1;document.documentElement.classList.toggle('ho-multi',!!multi);
      if(picker){picker.style.display=multi?'none':'';}
    }
    fs.addEventListener('change',function(e){if(e.target.name&&e.target.name.indexOf('ho-offer-')===0)sync();});
    sync();
    function pairVariant(row){
      var vals={};row.querySelectorAll('[data-opt]').forEach(function(el){if(el.tagName==='SELECT')vals[el.getAttribute('data-opt')]=el.value;else if(el.checked)vals[el.getAttribute('data-opt')]=el.value;});
      return variants.filter(function(v){return (!vals[1]||v.option1===vals[1])&&(!vals[2]||v.option2===vals[2])&&(!vals[3]||v.option3===vals[3])})[0];
    }
    var formId=fs.getAttribute('data-form');
    function onAdd(e){
      var c=current();if(!c||+c.getAttribute('data-qty')<2)return;
      var b=e.target.closest&&e.target.closest('button[type=submit],[name=add],.product-form__submit,.sticky-atc button,[id^="SectionAtcBtn-"]');if(e.type==='click'&&!b)return;
      e.preventDefault();e.stopImmediatePropagation();
      var map={};c.querySelectorAll('[data-ho-pair]').forEach(function(r){var v=pairVariant(r);if(v)map[v.id]=(map[v.id]||0)+1;});
      var items=Object.keys(map).map(function(id){return {id:+id,quantity:map[id]}});
      if(!items.length)return;
      if(b){b.setAttribute('aria-busy','true');b.disabled=true;}
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw r;location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';})
        .catch(function(){if(b){b.disabled=false;b.removeAttribute('aria-busy');}alert('Sorry, one of the pairs is not available. Please try another size or shade.');});
    }
    document.addEventListener('click',function(e){var b=e.target.closest('button[type=submit],[name=add],.product-form__submit,.sticky-atc button,[id^="SectionAtcBtn-"]');if(!b)return;var f=b.form||b.closest('form');if(!f||f.id===formId||b.closest('.sticky-atc')||String(b.id).indexOf('SectionAtcBtn-')===0)onAdd(e);},true);
    var form=formId&&document.getElementById(formId);if(form)form.addEventListener('submit',onAdd,true);
  });
  /* ---------- Livraison estimée (jours ouvrés) ---------- */
  document.querySelectorAll('[data-ho-ship]').forEach(function(el){
    function add(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d}
    var now=new Date(),a=add(now,+el.getAttribute('data-min')),b=add(now,+el.getAttribute('data-max'));
    var f={weekday:'short',day:'numeric',month:'short'},loc=document.documentElement.lang||'en-GB';
    var out=el.querySelector('[data-ho-dates]');if(out)out.textContent='between '+a.toLocaleDateString(loc,f)+' and '+b.toLocaleDateString(loc,f);
  });
  /* ---------- Avis : afficher plus ---------- */
  document.querySelectorAll('[data-ho-revmore]').forEach(function(b){b.addEventListener('click',function(){var l=document.querySelector('[data-ho-revlist]');l.querySelectorAll('[hidden]').forEach(function(x){x.hidden=false});b.parentNode.remove();});});

  /* ---------- Taille M par défaut ---------- */
  (function(){
    if(/[?&]variant=/.test(location.search))return;
    var vs=document.querySelector('variant-selects,variant-radios');if(!vs)return;
    var m=[].slice.call(vs.querySelectorAll('input[type=radio]')).filter(function(i){return i.value==='M'})[0];
    if(m&&!m.checked){m.click();}
  })();
  /* ---------- Calcul de taille ---------- */
  var SIZES=['XS','S','M','L','XL','2XL','3XL'];
  function pickSize(sz){
    var vs=document.querySelector('variant-selects,variant-radios');
    if(vs){var r=[].slice.call(vs.querySelectorAll('input[type=radio]')).filter(function(i){return i.value===sz})[0];if(r&&!r.checked)r.click();}
    document.querySelectorAll('.ho-pair__sel').forEach(function(s){if([].some.call(s.options,function(o){return o.value===sz}))s.value=sz;});
  }
  document.querySelectorAll('[data-ho-sf]').forEach(function(box){
    var panel=box.querySelector('.ho-sf__panel'),res=box.querySelector('[data-ho-sf-res]');
    box.querySelector('[data-ho-sf-open]').addEventListener('click',function(){panel.hidden=!panel.hidden;});
    function unit(){var c=box.querySelector('input[name=ho-sf-u]:checked');return c?c.value:'m';}
    function calc(){
      var u=unit();box.querySelectorAll('.ho-sf__row').forEach(function(r){r.hidden=r.getAttribute('data-u')!==u;});
      var h,w;
      if(u==='m'){h=+box.querySelector('[data-h]').value;w=+box.querySelector('[data-w]').value;}
      else{var ft=+box.querySelector('[data-ft]').value,inch=+box.querySelector('[data-in]').value||0;h=ft?(ft*12+inch)*2.54:0;var lb=+box.querySelector('[data-lb]').value;w=lb?lb*0.4536:0;}
      if(!h||!w||h<120||w<30){res.textContent='';return;}
      var bmi=w/Math.pow(h/100,2),i=bmi<19?0:bmi<21.5?1:bmi<24.5?2:bmi<28?3:bmi<32?4:bmi<36?5:6;
      if(h>=178&&i<6)i++;
      var sz=SIZES[i];
      res.innerHTML='Best fit for you: <b>'+sz+'</b> <button type="button">Select '+sz+'</button><br><span style="font-size:13px;color:var(--ho-ink-soft)">Between two sizes? Take the larger one.</span>';
      res.querySelector('button').addEventListener('click',function(){pickSize(sz);});
    }
    box.addEventListener('input',calc);box.addEventListener('change',calc);
  });
  /* ---------- Accordéons : un seul ouvert ---------- */
  document.querySelectorAll('[data-ho-acc]').forEach(function(g){g.addEventListener('toggle',function(e){if(e.target.open)g.querySelectorAll('details[open]').forEach(function(d){if(d!==e.target)d.open=false;});},true);});
  /* ---------- Avis : photos en grand ---------- */
  document.addEventListener('click',function(e){
    var img=e.target.closest('.ho-rev img');if(!img)return;
    var lb=document.createElement('div');lb.className='ho-lb';lb.innerHTML='<img alt="Customer photo"><button type="button" aria-label="Close">×</button>';
    lb.querySelector('img').src=img.src.replace(/width=\d+/,'width=1200');
    function close(){lb.remove();document.removeEventListener('keydown',esc);}
    function esc(k){if(k.key==='Escape')close();}
    lb.addEventListener('click',function(x){if(x.target===lb||x.target.tagName==='BUTTON')close();});
    document.addEventListener('keydown',esc);document.body.appendChild(lb);lb.querySelector('button').focus();
  });
  /* ---------- Gravure ---------- */
  document.querySelectorAll('[data-ho-perso]').forEach(function(fs){
    var names=[].slice.call(fs.querySelectorAll('[data-ho-name]')),out=fs.querySelector('[data-ho-preview]');
    function upd(){var v=names.map(function(n){return n.value.trim()}).filter(Boolean);out.textContent=v.join(' & ');}
    names.forEach(function(n){n.addEventListener('input',upd)});
    var formId=names[0]&&names[0].getAttribute('form');
    function guard(e){
      var inv=[].slice.call(fs.querySelectorAll('input[required]')).filter(function(i){return i.type==='checkbox'?!i.checked:!i.value.trim()});
      if(inv.length){e.preventDefault();e.stopImmediatePropagation();fs.scrollIntoView({behavior:'smooth',block:'center'});inv[0].reportValidity&&inv[0].reportValidity();inv[0].focus({preventScroll:true});}
    }
    document.addEventListener('click',function(e){var b=e.target.closest('button[type=submit],[name=add],.product-form__submit,[id^="SectionAtcBtn-"],.sticky-atc button');if(!b)return;var f=b.form||b.closest('form');if(!f||f.id===formId||b.closest('.sticky-atc')||String(b.id).indexOf('SectionAtcBtn-')===0)guard(e);},true);
    var form=formId&&document.getElementById(formId);if(form)form.addEventListener('submit',guard,true);
  });
  /* ---------- Teinte -> image de la galerie ---------- */
  (function(){
    var vEl=document.querySelector('[data-ho-variants]');var vars=[];try{vars=JSON.parse(vEl.textContent)}catch(e){}
    function show(shade){
      var v=vars.filter(function(x){return x.option1===shade&&x.featured_media})[0];if(!v)return;
      var mg=document.querySelector('media-gallery');if(!mg||!mg.setActiveMedia)return;
      try{mg.setActiveMedia(mg.id.replace('MediaGallery-','')+'-'+v.featured_media.id,false);}catch(e){}
    }
    document.addEventListener('change',function(e){
      var t=e.target;if(!t||t.type!=='radio')return;
      if(t.closest('.ho-pair')&&t.getAttribute('data-opt')==='1')return show(t.value);
      if(t.closest('variant-selects,variant-radios')&&vars.some(function(x){return x.option1===t.value}))setTimeout(function(){show(t.value)},60);
    });
  })();
  /* ---------- En-tete : FAQ et Contact a droite ---------- */
  (function(){
    var ul=document.querySelector('nav.header__inline-menu > ul'),icons=document.querySelector('.header__icons');
    if(!ul||!icons||icons.querySelector('.ho-nav-right'))return;
    var lis=[].slice.call(ul.children).filter(function(li){return /^(FAQ|Contact)$/i.test(li.textContent.trim())});
    if(!lis.length)return;
    var r=document.createElement('ul');r.className='list-menu list-menu--inline ho-nav-right';r.setAttribute('role','list');
    lis.forEach(function(li){r.appendChild(li)});icons.insertBefore(r,icons.firstChild);
  })();
})();
